import { useCallback } from 'react';

const useKeyEvents = ({
    onInputChange,
    predictiveInput,
    selectPreviousSuggestion,
    selectNextSuggestion,
    handleApplyTextSearch,
}: {
    onInputChange: (value: string) => void;
    predictiveInput: string;
    selectPreviousSuggestion: () => void;
    selectNextSuggestion: () => void;
    handleApplyTextSearch: () => void;
}) => {
    const handleKeyPress = useCallback(
        (event: React.KeyboardEvent<HTMLDivElement>): void => {
            event.stopPropagation();

            if (event.key === 'ArrowDown') {
                selectNextSuggestion();
            }

            if (event.key === 'ArrowUp') {
                selectPreviousSuggestion();
            }

            if (event.key === 'Enter') {
                handleApplyTextSearch();
            }
        },
        [handleApplyTextSearch, selectNextSuggestion, selectPreviousSuggestion],
    );

    const handleKeyDown = useCallback(
        (event: React.KeyboardEvent<HTMLDivElement>): void => {
            if (event.key === 'Tab' && !!predictiveInput) {
                event.stopPropagation();
                event.preventDefault();
                onInputChange(predictiveInput);
            }
        },
        [onInputChange, predictiveInput],
    );

    return { handleKeyPress, handleKeyDown };
};

export default useKeyEvents;
